import React, {useContext} from "react";
import "./Footer.scss";
import {motion} from "framer-motion";
import emoji from "react-easy-emoji";
import StyleContext from "../../contexts/StyleContext";

export default function Footer() {
  const {isDark} = useContext(StyleContext);
  return (
    <motion.div
      initial={{opacity: 0, y: 5}}
      animate={{opacity: 1, y: 0}}
      transition={{duration: 1}}
    >
      <div className="footer-div">
        <p className={isDark ? "dark-mode footer-text" : "footer-text"}>
          {emoji("Made with ❤️ by Ananda Muhamad Lukman")}
        </p>
        <p className={isDark ? "dark-mode footer-text" : "footer-text"}>
          Theme by <a href="https://anandalukman.vercel.app/">Ananda Lukman</a>
        </p>
      </div>
    </motion.div>
  );
}
